import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { DocumentService } from '../services/document.service';
import { PanelList } from '../../shared/models/panel-list';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-document-version-history',
  templateUrl: './document-version-history.component.html',
  styleUrls: ['./document-version-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentVersionHistoryComponent implements OnInit {
  @Input() documentDetailsDto!: DocumentDetailDto;
  @Output() isDocumentHistoryModalShow = new EventEmitter<boolean>();
  @Output() isCloseChangeRequestItemHistoryModal = new EventEmitter<boolean>();
  @Output() isLatestDocument = new EventEmitter<boolean>();
  noData: boolean = false;
  documentPhase = '';
  latestDocumentVersion = 0;
  isLatestVersion = false;
  isChangeRequestHistoryModalShow: boolean = false;
  readonly requiredPhasesToCheck=[1,2,3,4];
  readonly phasesForChangeRequestItemButtonVisible = [
    'Effective',
    'Obsolete',
    'Archived',
  ];
  viewDocumentHistoryModal = true;
  documentVersionsHistoryModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };
showLoader: boolean = false;

  constructor(
    private documentService: DocumentService,
    private router: Router,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getdocumentVersions();
  }
  getdocumentVersions = () => {
    this.showLoader = true;
    this.documentService
      .getDocumentVersions(this.documentDetailsDto.number)
      .subscribe((documentVersions) => {
        this.documentVersionsHistoryModalInput.lists = documentVersions;
        this.noData = this.commonService.IsListEmpty(documentVersions);
        this.showLoader = false;
        this.latestDocumentVersion =
          documentVersions && documentVersions.length > 0
            ? documentVersions[0]?.version
            : 0;
      });
  };

  openChangeRequestItemModal = (
    version: string,
    phase: number,
    phaseName: string
  ) => {
    this.generateDocumentDetailsDto(version, phase);
    this.isLatestVersion =
      this.latestDocumentVersion === Number(version) ? true : false;
    this.documentPhase = phaseName;
    this.isChangeRequestHistoryModalShow = true;
  };
  generateDocumentDetailsDto = (version: string, phase: number) => {
    this.documentDetailsDto.version = version;
    this.documentDetailsDto.phase = phase;
  };
  closeDocumentVersionHistoryModal = () => {
    this.viewDocumentHistoryModal = false;
    this.isDocumentHistoryModalShow.emit(false);
  };

  showOrHideChangeRequestItemButton = (phaseName: string): boolean => {
    return this.phasesForChangeRequestItemButtonVisible.indexOf(phaseName) !==
      -1
      ? true
      : false;
  };
  closeChangeRequestItemHistoryModal = (isShow: boolean) => {
    this.isChangeRequestHistoryModalShow = isShow;
  };
  updateIsLatestVersion(isLatest: boolean): void {
    this.isLatestVersion = isLatest;
    this.getdocumentVersions();
  }
  loadDocumentDetails = (version: string) => {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.documentDetails/' + this.documentDetailsDto.number + ':' + version,
      ])
    );
    window.open(url, '_blank');
  };

displayReqEffectiveDateField=(versionPhase:any):boolean=>{
  return this.requiredPhasesToCheck.indexOf(versionPhase) !== -1? true:false;
  }
displayEffectiveDateField=(versionPhase:any):boolean=>{
 return (this.requiredPhasesToCheck.indexOf(versionPhase) == -1) ? true: false;
  }

  calculatePhaseColor = (phaseName: string): string => {
    let statusColor = '';
    switch (phaseName) {
      case 'Collaboration':
        statusColor = 'collaboration';
        break;
      case 'QA Review':
        statusColor = 'qa_review';
        break;
      case 'Formatting':
        statusColor = 'formatting';
        break;
      case 'In Review':
        statusColor = 'in_review';
        break;
      case 'Ready For Approval':
        statusColor = 'ready_for_approval';
        break;
      case 'Approved':
        statusColor = 'approved';
        break;
      case 'Effective':
        statusColor = 'effective';
        break;
      case 'Archived':
        statusColor = 'archived';
        break;
      case 'Obsolete':
        statusColor = 'obsolete';
        break;
      case 'Cancelled':
        statusColor = 'cancelled';
        break;
        case 'Client Signature':
          statusColor = 'client_signature'
    }
    return statusColor;
  };
}
